import React, { createContext, useState, ReactNode, useContext, useRef, Dispatch, SetStateAction } from 'react';
import { useParams } from 'react-router-dom';
import { Hooks } from 'hooks/commonHooks';
import { MessageType } from 'models/BaseModel';
import { Code } from 'helpers/CalendarImports';

interface ListContextProps {
  keyId: string;
  setKeyId: Dispatch<SetStateAction<string>>;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
  search: string;
  setSearch: (search: string) => void;
  pno: number;
  setPno: (pno: number) => void;
  pageRows: number;
  setPageRow: (pageRows: number) => void;
  activeId : number;
  setActiveId : (activeId: number) => void;
  selected: boolean;
  setSelected: (selected: boolean) => void;
  confirm: MessageType; 
  setConfirm: Dispatch<SetStateAction<MessageType>>;
  message: MessageType;
  setMessage: Dispatch<SetStateAction<MessageType>>;
  showMenu: boolean;
  setShowMenu: (showMenu: boolean) => void;
  selectedItems: string[];
  setSelectedItems: (selectedKeyId: string[]) => void;
  selectAllChecked: boolean;
  setSelectAllChecked: (SelectAllChecked: boolean) => void;
  activeOptions: any;
  setActiveOptions: any;
  rowOptions: any;
  setRowOptions: any;
  menuPosition: any;
  setMenuPosition: any;
  //isAllSelected: boolean
  iframeRef: any;
  iframeRef2: any;
  filterRef: any;
  contextMenuRef: any;
}

const ListContext = createContext<ListContextProps | undefined>(undefined);

export const ListProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { keyId: paramKeyId } = useParams<{ keyId: string }>();
  const [keyId, setKeyId] = useState<string>(paramKeyId || '');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [search, setSearch] = useState<string>("");
  const [pno, setPno] = useState<number>(1);
  const [pageRows, setPageRow] = useState<number>(20);
  const [activeId, setActiveId] = useState<number>(2);
  const [selected, setSelected] = useState<boolean>(false);
  const [confirm, setConfirm] = useState<MessageType>(Code.Message.None);
  const [message, setMessage] = useState<MessageType>(Code.Message.None);
  const [showMenu, setShowMenu] = useState<boolean>(false); 
  const [menuPosition, setMenuPosition] = Hooks.Form.Position(); 
  const [activeOptions, setActiveOptions] = Hooks.Form.Options();
  const [rowOptions, setRowOptions] = Hooks.Form.Options();
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const iframeRef = Hooks.Form.Frame();
  const iframeRef2 = Hooks.Form.Frame();
  const filterRef = Hooks.Form.Div();
  const contextMenuRef = Hooks.Form.Div();
  //const isAllSelected = false;

  return (
    <ListContext.Provider value={{
      keyId, setKeyId,
      loading, setLoading, 
      error, setError, 
      search, setSearch, 
      pno, setPno, 
      pageRows, setPageRow, 
      activeId, setActiveId, 
      activeOptions, setActiveOptions, 
      rowOptions, setRowOptions, 
      selected, setSelected, 
      confirm, setConfirm,
      message, setMessage, 
      showMenu, setShowMenu, 
      selectedItems, setSelectedItems, 
      menuPosition, setMenuPosition, 
      selectAllChecked, setSelectAllChecked, 
      iframeRef, 
      iframeRef2, 
      filterRef, 
      contextMenuRef
    }}>
      {children}
    </ListContext.Provider>
  );
};

export const useListContext = () => {
  const context = useContext(ListContext);
  if (context === undefined) {
    throw new Error('useListContext must be used within a ListProvider');
  }
  return context;
};